import axios from 'axios';

// Define API types
type ApiType = 'user' | 'admin' | 'mainAdmin' | 'ayurveda' | 'humanPyschology';

// Function to create axios instance with dynamic baseURL
const createAxiosInstance = (apiType: ApiType = 'user') => {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001';
    let baseURL = '';

    switch (apiType) {
        case 'user':
            baseURL = `${apiBaseUrl}/user/api/v1`;
            break;
        case 'admin':
            baseURL = `${apiBaseUrl}/admin/api/v1`;
            break;
        case 'mainAdmin':
            baseURL = `${apiBaseUrl}/admin/api/v2`;
            break;
        case 'ayurveda':
            baseURL = `${apiBaseUrl}/ayurveda/api/v1`;
            break;
        case 'humanPyschology':
            baseURL = `${apiBaseUrl}/humanPsychology/api/v1`;
            break;
        default:
            baseURL = `${apiBaseUrl}/user/api/v1`;
    }

    const instance = axios.create({
        baseURL,
        headers: {
            "Cache-Control": "no-cache, no-store, must-revalidate",
            "Pragma": "no-cache",
            "Expires": "0"
        },
        withCredentials: true
    });

    // Request interceptor
    instance.interceptors.request.use((config) => {
        // Check for mentorAccessToken, userAccessToken, or adminAccessToken
        const token = sessionStorage.getItem('mentorAccessToken') || sessionStorage.getItem('userAccessToken') || sessionStorage.getItem('adminAccessToken');
        if (token) {
            if (!config.headers) {
                config.headers = {};
            }
            config.headers.Authorization = `Bearer ${token}`;
        }

        // Only set Content-Type if not FormData
        if (config.data && !(config.data instanceof FormData)) {
            if (!config.headers) {
                config.headers = {};
            }
            config.headers['Content-Type'] = 'application/json';
        }

        return config;
    }, (reject) => {
        return Promise.reject(reject);
    });

    // Response interceptor
    instance.interceptors.response.use((response) => {
        return response;
    }, (reject) => {
        return Promise.reject(reject);
    });

    return instance;
};

// Example Usage
const userApi = createAxiosInstance('user'); // for user API
const adminApi = createAxiosInstance('admin'); // for admin API
const mainAdminApi = createAxiosInstance('mainAdmin'); // for main admin API
const ayurvedicApi = createAxiosInstance('ayurveda'); // for ayurvedic API
const humanPsychologyApi = createAxiosInstance('humanPyschology'); // for humanPsychology API
export { userApi, adminApi, mainAdminApi, ayurvedicApi, humanPsychologyApi };